export var toKebabCase = function (value) {
    return value.toLocaleLowerCase().replace(/\s/g, "-");
};
